export const CMS_PAGE_MAP: Record<
    string,
    {
        pageName: string;   // CMS / API PageName
        titleKey: string;  // localization key (EN/HI already exists)
    }
> = {
    "about-us": {
        pageName: "About Us",
        titleKey: "aboutus_page"
    },
    "kyc-policy": {
        pageName: "KYCPolicy",
        titleKey: "kyc-policy"
    },
    "help": {
        pageName: "Help",
        titleKey: "help"
    },
    "terms-and-conditions": {
        pageName: "TermsAndConditions",
        titleKey: "terms-and-conditions"
    },
    "payment-methods": {
        pageName: "Payment Methods",
        titleKey: "payment-methods"
    },
    "self-exclusion-policy": {
        pageName: "SelfExclusionPolicy",
        titleKey: "self_exclusion_policy_page"
    },
    "responsible-gaming": {
        pageName: "ResponsibleGaming",
        titleKey: "responsible-gaming"
    },
    "privacy-policy": {
        pageName: "PrivacyPolicy",
        titleKey: "privacy_policy"
    },
    "glossary": {
        pageName: "Glossary",
        titleKey: "glossary"
    },
    "exchange-rules": {
        pageName: "Exchange Rules",
        titleKey: "exchange_rules"
    },
    "sportsbook-rules": {
        pageName: "Sportsbook Rules",
        titleKey: "sportsbook_rules"
    },
    "affiliates": {
        pageName: "Affiliates",
        titleKey: "affiliates_page"
    },
    "blog": {
        pageName: "Blog",
        titleKey: "blog_page"
    }
};
